/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import LoadingComponent from 'components/loading';
import ConfirmingAddSupplierTabContactViewComponent from './view';

import CompanyContactPerson from 'models/companies/companyContactPerson';
import SupplierCompany from 'models/confirming/supplierCompany';

import SetInvoiceContactPersonsRequest from 'models/requests/sellers/setInvoiceContactPersonsRequest';

import CompanyService from 'services/CompanyService';
import InvoiceSellerService from 'services/InvoiceSellerService';
import { handleApiFormResponse } from 'lib/forms';
import NotificationHelper from 'lib/notifications';
import ConfirmingService from 'services/ConfirmingService';
import AddSupplierContactPersonRequest from 'models/requests/confirming/AddSupplierContactPersonRequest';

type ConfirmingAddSupplierTabContactComponentProps = {
  supplierId: number;
  activeCompanyId: number;
  successHandler: () => void;
  cancelInvoice: () => void;
}

type ConfirmingAddSupplierTabContactComponentState = {
  contactPerson: CompanyContactPerson;
  contactPersons: CompanyContactPerson[];
  supplierCompany: SupplierCompany;
  displayForm: boolean;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
}

class ConfirmingAddSupplierTabContactComponent extends React.Component<ConfirmingAddSupplierTabContactComponentProps, ConfirmingAddSupplierTabContactComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      contactPersons: null,
      displayForm: false,
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    let supplierCompanyDetails = await ConfirmingService.getConfirmingSupplierDetails(this.props.activeCompanyId, this.props.supplierId);
    const contactPersons = supplierCompanyDetails.contactPersons;
    this.setState({
      contactPersons,
      isLoading: false,
      supplierCompany: supplierCompanyDetails
    });
  }

  selectContact = (contactPersonId: number) => {
    try {
      const contactPersons = this.state.contactPersons;
      let contactPerson = contactPersons.find(x => x.id === contactPersonId);
      this.setState({ contactPerson });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR, e.message);
    }
  }

  unSelectContact = (contactPersonId: number) => {
    this.setState({ contactPerson: null });
  }

  handleContactCreated = (contactPerson: CompanyContactPerson) => {
    const contactPersons = this.state.contactPersons;
    contactPersons.push(contactPerson);

    this.setState({
      contactPersons,
      displayForm: false
    });
  }

  submitForm = async () => {
    if (this.state.contactPerson === null) {
      return;
    }

    this.setState({ isProcessing: true });

    try {
      // const request = new AddSupplierContactPersonRequest(this.props.activeCompanyId, this.props.supplierId, this.state.contactPerson.titleId, this.state.contactPerson.lastName, this.state.contactPerson.firstName, this.state.contactPerson.email, this.state.contactPerson.languageId, this.state.contactPerson.functionName);
      // await ConfirmingService.setSupplierLeadContact(request);
      this.props.successHandler(this.props.supplierId);
    } catch (e) {
      this.setState({ isProcessing: false });
      handleApiFormResponse.call(this, e);
    }
  }

  skipStep = () => {
    this.setState({ isProcessing: true });
    this.props.successHandler(this.props.supplierId);
  }

  toggleContactForm = () => this.setState(prevState => ({ displayForm: !prevState.displayForm }));

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <ConfirmingAddSupplierTabContactViewComponent
        selectedContactPerson={this.state.contactPerson}
        contactPersons={this.state.contactPersons}
        supplierCompany={this.state.supplierCompany}
        displayForm={this.state.displayForm}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        skipStep={this.skipStep}
        handleContactCreated={this.handleContactCreated}
        selectContact={this.selectContact}
        submitForm={this.submitForm}
        toggleContactForm={this.toggleContactForm}
        unSelectContact={this.unSelectContact}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(ConfirmingAddSupplierTabContactComponent);
